import { render } from "./App.vue?vue&type=template&id=6a0e8744"
const script = {}

import exportComponent from "/var/www/music-social-network/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__